import {Injectable} from '@angular/core';
import {Configurator, OccConfiguratorVariantAddToCartSerializer} from '@spartacus/product-configurator/rulebased';
import {DcpOccAddToCartParameters} from '../models/dcp-cps-configurator.model';

@Injectable({providedIn: 'root'})
export class DCPOccConfiguratorVariantAddToCartSerializer extends OccConfiguratorVariantAddToCartSerializer {
  override convert(
    source: Configurator.AddToCartParameters,
    target?: DcpOccAddToCartParameters,
  ): DcpOccAddToCartParameters {
    return {
      ...target,
      userId: source.userId,
      cartId: source.cartId,
      product: {
        code: source.productCode,
        technicalName: source.technicalName,
      },
      quantity: source.quantity,
      configId: source.configId,
      transactionType: source.transactionType,
      cancellationUrl: source.cancellationUrl,
    };
  }
}
